import { setEngagementTime } from '../actions/authActions';
import { addEngagement, getChatHistoryConversation, getChatConversationForMiddleware, getChatHistory } from '../actions/dataConsoleAction';
import { getChatHistoryConversationData } from '../apis/index';
import moment from 'moment';

let currentUserId = null; // Move currentUserId outside the middleware function
let startTime = null;
let currentChatId = null;
let currentDatasetId = null;
let isTimerPaused = false;
let pausedTime = null;

const handleVisibilityChange = () => {
  if (document.hidden) {
    // Pause the timer
    if (startTime !== null) {
      isTimerPaused = true;
      pausedTime = Date.now();
      console.log("Timer paused for chatId:", currentChatId);
    }
  } else {
    // Resume the timer
    if (isTimerPaused && pausedTime !== null) {
      const pauseDuration = Date.now() - pausedTime;
      startTime += pauseDuration; // Adjust startTime to account for the pause duration
      isTimerPaused = false;
      pausedTime = null;
      console.log("Timer resumed for chatId:", currentChatId);
    }
  }
};

document.addEventListener('visibilitychange', handleVisibilityChange);

window.addEventListener('beforeunload', (event) => {
  if (startTime !== null) {
    const message = "You have an active session. Are you sure you want to leave?";
    event.returnValue = message; // Standard for most browsers
    return message; // For some older browsers
  }
});

// Fire-and-forget engagement tracking for the chat the user just left.
// This performs its own network call and dispatch, but must never block or
// delay delivery of the action that triggered the chat-id change (or any
// action dispatched shortly after) to the reducer — ChatBot.js's own
// conversation-loading actions pass through this same middleware, and if
// this were awaited before forwarding, it would delay the reducer resetting
// chatData/chatDataStatus for the newly-selected chat.
const trackEngagementForPreviousChat = async (dispatch, getChatId, getDatasetId, engagementTime) => {
  try {
    const response = await getChatConversationForMiddleware(getChatId);

    // Assuming response contains userId in `data[0].userId`
    const userId = response?.data?.[0]?.userId;
    if (userId) {
      currentUserId = userId;
      console.log("Fetched and set userId:", currentUserId);
    } else {
      console.warn("UserId not found in SaveHistoryConversation response.");
    }

    // Count user questions from the fetched conversation. Kept local (not the
    // old module-level counters) so overlapping chat switches can't stomp on
    // each other's counts.
    let numOfQuestions = 0;
    const userQuestions = [];
    const data = response?.data || [];
    data.forEach(item => {
      const userQuestion = item?.userQuestion;
      if (userQuestion) {
        numOfQuestions += 1;
        userQuestions.push(userQuestion);
      }
    });

    const payload = {
      userId: currentUserId,
      datasetId: getDatasetId,
      chatId: getChatId,
      timestamp: new Date().toISOString(),
      sessionDurationInSec: engagementTime,
      metaData: {
        numOfQuestions,
        userQuestions,
        conversationType: "Short",
        isUserLeftChat: true,
        isExternalUser: false, // ✅ Normal users are not external users
      },
    };
    dispatch(addEngagement(payload));
  } catch (error) {
    console.error("Failed to fetch userId and userQuestion from SaveHistoryConversation:", error);
  }
};

const timerMiddleware = ({ dispatch, getState }) => {
  return (next) => (action) => {
    // ✅ Skip tracking for external users (they have their own heartbeat tracking)
    const isExternalUser = localStorage.getItem("isExternalUser") === "true";
    if (isExternalUser) {
      return next(action); // Skip timer middleware for external users
    }

    // Always forward the action immediately. Nothing below this line may
    // delay or reorder delivery of the current (or any subsequent) action.
    const result = next(action);

    const urlParams = new URLSearchParams(window.location.search);
    const chatBotQueryParam = urlParams.get("cid");
    const newDatasetId = urlParams.get("c");

    if (chatBotQueryParam !== currentChatId) {
      const getChatId = currentChatId;
      const getDatasetId = currentDatasetId;

      // Claim this transition synchronously so an overlapping action
      // dispatched moments later sees the update and doesn't re-trigger it.
      currentChatId = chatBotQueryParam;
      currentDatasetId = newDatasetId;

      if (getChatId !== null && startTime !== null) {
        // Stop timer when chatId changes
        const endTime = Date.now();
        const engagementTime = (endTime - startTime) / 1000; // Calculate engagement time in seconds
        console.log("Timer stopped for chatId:", getChatId, "Engagement time:", engagementTime);
        startTime = null; // Reset timer

        trackEngagementForPreviousChat(dispatch, getChatId, getDatasetId, engagementTime);
      }

      if (chatBotQueryParam !== null) {
        startTime = Date.now();
        console.log("Timer started for chatId:", chatBotQueryParam);
      }
    }

    return result;
  };
};

// // Function to set the userId manually if needed
// export const setUserId = (userId) => {
// currentUserId = userId;
// console.log("UserId manually set:", currentUserId);
// };

export default timerMiddleware;